import { Injectable } from '@angular/core';

const STORAGE_KEY = 'entryMarked';

/**
 * このタブが外部アプリからの入口（/entry）を通ったかどうかの印を管理する。
 * sessionStorage はタブ単位で、同一オリジンへ戻れば Cognito を経由しても残るため、
 * 入口を通ったタブではリロードしても使い続けられ、ドメインを直接開いたタブは弾ける。
 * 認証そのものは BFF のセッション Cookie で行う。印はセキュリティ境界ではない。
 */
@Injectable({ providedIn: 'root' })
export class EntryMarker {
  mark(): void {
    sessionStorage.setItem(STORAGE_KEY, '1');
  }

  isMarked(): boolean {
    return sessionStorage.getItem(STORAGE_KEY) !== null;
  }

  clear(): void {
    sessionStorage.removeItem(STORAGE_KEY);
  }
}
